import React from "react";

export const PathContext = React.createContext<Array<number | string>>([]);
export const PathContextProvider = PathContext.Provider;
